import TextModal from "@coworker/apprestructured/src/task-management/components/TextModal/TextModal";
import { useTranslation } from "@coworker/locales";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { Ref, useCallback } from "react";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type TextModalCreatorFragmentConfigProps = {
  // Translation key for the title
  title: string;
  field: string;
  maxLength: number;
};

type TextModalCreatorFragmentProps = {
  configProps: TextModalCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function TextModalCreatorFragment({
  configProps,
  commonProps,
}: TextModalCreatorFragmentProps) {
  const { field, title, maxLength } = configProps;
  const { blockInput, task, onTaskChange, taskType } = commonProps;
  const text = validateInitialDetailsFieldValue<string>(
    getByPath(task, field),
    field,
    taskType
  );

  const { t } = useTranslation();

  const handleConfirmClick = useCallback(
    (newText: string) => {
      onTaskChange(setByPath(field, newText));
    },
    [field, onTaskChange]
  );

  if (isLoading(text)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <TextModal
      title={t(title)}
      text={text ?? ""}
      onConfirmClick={handleConfirmClick}
      disabled={blockInput}
      maxLength={maxLength}
    />
  );
}

export default TextModalCreatorFragment;
